// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y5D2zCekFy_IL3Gc2xzD {
	display: flex;
	flex-direction: column;
}

.gJzWIs4gwjDoVA5hJKgS {
	color: var(--black);
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 24px;
	margin-bottom: 8px;
}

.VVKxaARKUdo_zOVdPDWQ {
	display: flex;
	flex-direction: column;
}

.VVKxaARKUdo_zOVdPDWQ > * {
		border-top: 0.5px solid rgba(0, 0, 0, 0.2);
	}
`, "",{"version":3,"sources":["webpack://./src/pages/ConfirmLockPage/Details/Details.pcss"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,sBAAsB;AAKvB;;AAHC;EACC,0CAA0C;CAC3C","sourcesContent":[".container {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.label {\n\tcolor: var(--black);\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 24px;\n\tmargin-bottom: 8px;\n}\n\n.content {\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& > * {\n\t\tborder-top: 0.5px solid rgba(0, 0, 0, 0.2);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Y5D2zCekFy_IL3Gc2xzD`,
	"label": `gJzWIs4gwjDoVA5hJKgS`,
	"content": `VVKxaARKUdo_zOVdPDWQ`
};
export default ___CSS_LOADER_EXPORT___;
